





























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import { classroomList } from '@/api/teachingProtection/teachManage'
import { lunchExport, lunchOrderStatic } from '@/api/teachingProtection/childCare'

@Component({
  name: 'static',
  components: {
    Chart
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [Date.now(), Date.now()]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromRecordTime: Date.now(),
    toRecordTime: Date.now(),
    classroomIds: []

  };
  private recordForm: any = {
    fromRecordTime: Date.now(),
    toRecordTime: Date.now(),
    classroomId: '',
    breakfastInSchool: '',
    lunchInSchool: '',
    studentName: ''

  };

  private classList:any = [] // 班级
  private series:any = [
    {
      name: '在园用餐',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '不在园用餐',
      type: 'bar',
      stack: '记录',
      data: []
    }
  ]
  private options: any = {
    color: ['#7CB8F8', '#FF8A8A', '#FFD805', '#46AE84', '#BD8DEF', '#70B603'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['早餐在园用餐', '早餐不在园用餐', '午餐在园用餐', '午餐不在园用餐']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '班级',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：人'
      }
    ],
    series: [
      {
        name: '早餐在园用餐',
        type: 'bar',
        stack: '早餐统计',
        emphasis: {
          focus: 'series'
        },
        data: []
      },
      {
        name: '早餐不在园用餐',
        type: 'bar',
        stack: '早餐统计',
        emphasis: {
          focus: 'series'
        },
        data: []
      },
      {
        name: '午餐在园用餐',
        type: 'bar',
        stack: '午餐统计',
        emphasis: {
          focus: 'series'
        },
        data: []
      },
      {
        name: '午餐不在园用餐',
        type: 'bar',
        stack: '午餐统计',
        emphasis: {
          focus: 'series'
        },
        data: []
      }
    ]
  };

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromRecordTime = newVal.length ? newVal[0] : ''
    this.staticForm.toRecordTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromRecordTime = newVal.length ? newVal[0] : ''
    this.recordForm.toRecordTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }
  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await lunchExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 柱状图
   */
  private getStatic() {
    this.options.xAxis[0].data = []
    this.options.series[0].data = []
    this.options.series[1].data = []
    this.options.series[2].data = []
    this.options.series[3].data = []
    lunchOrderStatic({
      ...this.staticForm
    }).then(res => {
      (res.data.array || []).map((item:any) => {
        this.options.xAxis[0].data.push(item.classroomName)
        this.options.series[0].data.push(item.breakfastInSchoolNum)
        this.options.series[1].data.push(item.breakfastNotInSchoolNum)
        this.options.series[2].data.push(item.lunchInSchoolNum)
        this.options.series[3].data.push(item.lunchNotInSchoolNum)
      });
      (this.$refs.staticChart as any).setOption(this.options)
    }).catch(() => {})
  }
  /**
   * 统计查询
   */
  private staticSearch() {
    this.getStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.getStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromRecordTime = this.recordTime[0]
    this.recordForm.toRecordTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 记录时间筛选
   */
  private getRecord() {
    this.recordSearch()
  }
}
